import ShipStatsVector from "./ship-stats-vector.js";
import ShipConfig from "./ship-config.js";

// Everything that defines a ship type
export default class ShipDesign {
    constructor(data) {
        if (data) { // "copy ctor"
            Object.assign(this, JSON.parse(JSON.stringify(data)));
            this.config = new ShipConfig(this.config);
        } else {
            this.id = null;
            this.name = null;
            this.owner_id = null;
            this.owner_name = null;
            this.build_count = 0;
            this.config = new ShipConfig();
            this.stats = new ShipStatsVector();
        }
    }

    refreshStats() {
        this.config.refreshHullLevel();
        this.stats = new ShipStatsVector().initFromConfiguration(this.config);
    }
}